module.exports = __webpack_public_path__ + "img/185.fd6e0ee3.jpg";